import { createMuiTheme } from '@material-ui/core/styles'

const primary = '#000000'
const secondary = '#c51144'
const error = '#FBAB7E'

export default createMuiTheme({
  palette: {
    primary: {
      main: primary,
      // dark: '#0049ac',
      light: '#90ecfd',
      textColor: '#ffffff'
    },
    secondary: {
      main: secondary
    },
    error: {
      main: error
    }
  },
  typography: {
    fontFamily: ['playregular-Regular', 'Open Sans', 'sans-serif'].join(','),
    useNextVariants: true
  },
  overrides: {
    // MuiFormLabel: {
    //   focused: {
    //     color: ["#000", '!important']
    //   }
    // },
    // MuiFormControl: {
    // 	root: {
    // 		margin: 0,
    // 		border: 0,
    // 		display: 'inline-flex',
    // 		padding: 0,
    // 		position: 'relative',
    // 		minWidth: 0,
    // 		flexDirection: 'inherit',
    // 		verticalAlign: 'top'
    // 	}
    // },
    // MuiInput: {
    //   underline: {
    //     '&$focused:after': {
    //       borderBottomColor: [primary, '!important']
    //     }
    //   },
    //   root: {
    //     position: 'unset'
    //   }
    // },
    MuiButton: {
      containedSecondary: {
        boxShadow:
          '0px 0px 0px -1px rgba(0, 0, 0, 0.2), 0px 2px 9px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.2)'
        // boxShadow: `0px 1px 1px 0px ${hexToRgbA(secondary,0.2)}, 0px 4px 8px 0px ${hexToRgbA(secondary,0.14)}, 0px 3px 5px 1px ${hexToRgbA(secondary,0.12)}`
      },
      raisedPrimary: {
        color: '#fff',
        boxShadow:
          '0px 0px 0px -1px rgba(0, 0, 0, 0.2), 0px 2px 9px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.2)'
        // boxShadow: `0px 1px 1px 0px ${hexToRgbA(primary,0.2)}, 0px 4px 8px 0px ${hexToRgbA(primary,0.14)}, 0px 3px 5px 1px ${hexToRgbA(primary,0.12)}`
      },
      disabled: {
        opacity: '0.65'
      },
      fab: {
        boxShadow:
          '0px 0px 0px -1px rgba(0, 0, 0, 0.2), 0px 2px 9px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.2)'
        // boxShadow: `0px 1px 1px 0px ${hexToRgbA(primary,0.2)}, 0px 4px 8px 0px ${hexToRgbA(primary,0.14)}, 0px 3px 5px 1px ${hexToRgbA(primary,0.12)}`
      }
    },
    MuiCard: {
      root: {
        boxShadow:
          '0px 0px 0px -1px rgba(0, 0, 0, 0.1), 0px 2px 16px 0px rgba(0, 0, 0, 0.1), 0px 0px 2px 0px rgba(0, 0, 0, 0.1)'
      }
    },
    MuiCardContent: {
      root: {
        '@media (min-width: 600px)': {
          paddingLeft: 16,
          paddingRight: 16
        }
      }
    },
    MuiCardHeader: {
      root: {
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 16,
        paddingBottom: 16
      }
    },
    MuiCardActionArea: {
      root: {
        display: 'flex'
      }
    },
    MuiCardActions: {
      root: {
        padding: '0px 8px',
        justifyContent: 'center'
      }
    },
    MuiAppBar: {
      positionStatic: {
        position: 'relative'
      },
      colorPrimary: {
        color: '#fff'
      }
    },
    MuiPaper: {
      elevation1: {
        boxShadow:
          '0px 0px 0px -1px rgba(0, 0, 0, 0.1), 0px 1px 7px 0px rgba(0, 0, 0, 0.1), 0px 0px 0px 0px rgba(0, 0, 0, 0.1)'
      },
      elevation2: {
        boxShadow:
          '0px 0px 0px -1px rgba(0, 0, 0, 0.16), 0px 4px 16px 0px rgba(0, 0, 0, 0.16), 0px 0px 4px 0px rgba(0, 0, 0, 0.16)'
      }
    },
    MuiDialog: {
      paper: {
        margin: '36px'
      }
    }
  }
})
